/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { WeaknessInstanceEntity } from './WeaknessInstanceEntity';
import {
    WeaknessInstanceEntityFromJSON,
    WeaknessInstanceEntityFromJSONTyped,
    WeaknessInstanceEntityToJSON,
    WeaknessInstanceEntityToJSONTyped,
} from './WeaknessInstanceEntity';
import type { BaselineEntity } from './BaselineEntity';
import {
    BaselineEntityFromJSON,
    BaselineEntityFromJSONTyped,
    BaselineEntityToJSON,
    BaselineEntityToJSONTyped,
} from './BaselineEntity';
import type { AssetEntity } from './AssetEntity';
import {
    AssetEntityFromJSON,
    AssetEntityFromJSONTyped,
    AssetEntityToJSON,
    AssetEntityToJSONTyped,
} from './AssetEntity';
import type { Case } from './Case';
import {
    CaseFromJSON,
    CaseFromJSONTyped,
    CaseToJSON,
    CaseToJSONTyped,
} from './Case';
import type { VulnerabilityInstanceEntity } from './VulnerabilityInstanceEntity';
import {
    VulnerabilityInstanceEntityFromJSON,
    VulnerabilityInstanceEntityFromJSONTyped,
    VulnerabilityInstanceEntityToJSON,
    VulnerabilityInstanceEntityToJSONTyped,
} from './VulnerabilityInstanceEntity';

/**
 * Boundary data
 * @export
 * @interface SystemBoundaryEntity
 */
export interface SystemBoundaryEntity {
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    status?: SystemBoundaryEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SystemBoundaryEntity
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SystemBoundaryEntity
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    description?: string;
    /**
     * 
     * @type {SystemBoundaryEntity}
     * @memberof SystemBoundaryEntity
     */
    parentBoundary?: SystemBoundaryEntity;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    boundaryType?: SystemBoundaryEntityBoundaryTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemBoundaryEntity
     */
    complianceFrameworks?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemBoundaryEntity
     */
    dataClassifications?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    authorizationStatus?: SystemBoundaryEntityAuthorizationStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    authorizationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    authorizationExpiration?: Date;
    /**
     * 
     * @type {number}
     * @memberof SystemBoundaryEntity
     */
    daysUntilExpiration?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SystemBoundaryEntity
     */
    isExpired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    authorizationAuthority?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    authorizationReference?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SystemBoundaryEntity
     */
    boundaryAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SystemBoundaryEntity
     */
    networkScope?: { [key: string]: any; };
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof SystemBoundaryEntity
     */
    dataFlows?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Set<AssetEntity>}
     * @memberof SystemBoundaryEntity
     */
    assets?: Set<AssetEntity>;
    /**
     * 
     * @type {Set<User>}
     * @memberof SystemBoundaryEntity
     */
    users?: Set<User>;
    /**
     * 
     * @type {Set<Case>}
     * @memberof SystemBoundaryEntity
     */
    cases?: Set<Case>;
    /**
     * 
     * @type {Set<VulnerabilityInstanceEntity>}
     * @memberof SystemBoundaryEntity
     */
    vulnerabilities?: Set<VulnerabilityInstanceEntity>;
    /**
     * 
     * @type {Set<WeaknessInstanceEntity>}
     * @memberof SystemBoundaryEntity
     */
    weaknesses?: Set<WeaknessInstanceEntity>;
    /**
     * 
     * @type {number}
     * @memberof SystemBoundaryEntity
     */
    assetCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemBoundaryEntity
     */
    aggregatedRiskScore?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    complianceStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemBoundaryEntity
     */
    complianceScore?: number;
    /**
     * 
     * @type {Date}
     * @memberof SystemBoundaryEntity
     */
    complianceAssessedAt?: Date;
    /**
     * 
     * @type {Set<BaselineEntity>}
     * @memberof SystemBoundaryEntity
     */
    defaultBaselines?: Set<BaselineEntity>;
    /**
     * 
     * @type {string}
     * @memberof SystemBoundaryEntity
     */
    defaultBaselineId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SystemBoundaryEntity
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SystemBoundaryEntity
     */
    decommissioned?: boolean;
}


/**
 * @export
 */
export const SystemBoundaryEntityStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type SystemBoundaryEntityStatusEnum = typeof SystemBoundaryEntityStatusEnum[keyof typeof SystemBoundaryEntityStatusEnum];

/**
 * @export
 */
export const SystemBoundaryEntityBoundaryTypeEnum = {
    System: 'SYSTEM',
    Enclave: 'ENCLAVE',
    Application: 'APPLICATION',
    Environment: 'ENVIRONMENT',
    Service: 'SERVICE'
} as const;
export type SystemBoundaryEntityBoundaryTypeEnum = typeof SystemBoundaryEntityBoundaryTypeEnum[keyof typeof SystemBoundaryEntityBoundaryTypeEnum];

/**
 * @export
 */
export const SystemBoundaryEntityAuthorizationStatusEnum = {
    Authorized: 'AUTHORIZED',
    InterimAuthorization: 'INTERIM_AUTHORIZATION',
    NotAuthorized: 'NOT_AUTHORIZED',
    Denied: 'DENIED',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type SystemBoundaryEntityAuthorizationStatusEnum = typeof SystemBoundaryEntityAuthorizationStatusEnum[keyof typeof SystemBoundaryEntityAuthorizationStatusEnum];


/**
 * Check if a given object implements the SystemBoundaryEntity interface.
 */
export function instanceOfSystemBoundaryEntity(value: object): value is SystemBoundaryEntity {
    return true;
}

export function SystemBoundaryEntityFromJSON(json: any): SystemBoundaryEntity {
    return SystemBoundaryEntityFromJSONTyped(json, false);
}

export function SystemBoundaryEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemBoundaryEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'parentBoundary': json['parentBoundary'] == null ? undefined : SystemBoundaryEntityFromJSON(json['parentBoundary']),
        'boundaryType': json['boundaryType'] == null ? undefined : json['boundaryType'],
        'complianceFrameworks': json['complianceFrameworks'] == null ? undefined : json['complianceFrameworks'],
        'dataClassifications': json['dataClassifications'] == null ? undefined : json['dataClassifications'],
        'authorizationStatus': json['authorizationStatus'] == null ? undefined : json['authorizationStatus'],
        'authorizationDate': json['authorizationDate'] == null ? undefined : (new Date(json['authorizationDate'])),
        'authorizationExpiration': json['authorizationExpiration'] == null ? undefined : (new Date(json['authorizationExpiration'])),
        'daysUntilExpiration': json['daysUntilExpiration'] == null ? undefined : json['daysUntilExpiration'],
        'isExpired': json['isExpired'] == null ? undefined : json['isExpired'],
        'authorizationAuthority': json['authorizationAuthority'] == null ? undefined : json['authorizationAuthority'],
        'authorizationReference': json['authorizationReference'] == null ? undefined : json['authorizationReference'],
        'boundaryAttributes': json['boundaryAttributes'] == null ? undefined : json['boundaryAttributes'],
        'networkScope': json['networkScope'] == null ? undefined : json['networkScope'],
        'dataFlows': json['dataFlows'] == null ? undefined : json['dataFlows'],
        'assets': json['assets'] == null ? undefined : (new Set((json['assets'] as Array<any>).map(AssetEntityFromJSON))),
        'users': json['users'] == null ? undefined : (new Set((json['users'] as Array<any>).map(UserFromJSON))),
        'cases': json['cases'] == null ? undefined : (new Set((json['cases'] as Array<any>).map(CaseFromJSON))),
        'vulnerabilities': json['vulnerabilities'] == null ? undefined : (new Set((json['vulnerabilities'] as Array<any>).map(VulnerabilityInstanceEntityFromJSON))),
        'weaknesses': json['weaknesses'] == null ? undefined : (new Set((json['weaknesses'] as Array<any>).map(WeaknessInstanceEntityFromJSON))),
        'assetCount': json['assetCount'] == null ? undefined : json['assetCount'],
        'aggregatedRiskScore': json['aggregatedRiskScore'] == null ? undefined : json['aggregatedRiskScore'],
        'complianceStatus': json['complianceStatus'] == null ? undefined : json['complianceStatus'],
        'complianceScore': json['complianceScore'] == null ? undefined : json['complianceScore'],
        'complianceAssessedAt': json['complianceAssessedAt'] == null ? undefined : (new Date(json['complianceAssessedAt'])),
        'defaultBaselines': json['defaultBaselines'] == null ? undefined : (new Set((json['defaultBaselines'] as Array<any>).map(BaselineEntityFromJSON))),
        'defaultBaselineId': json['defaultBaselineId'] == null ? undefined : json['defaultBaselineId'],
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
    };
}

export function SystemBoundaryEntityToJSON(json: any): SystemBoundaryEntity {
    return SystemBoundaryEntityToJSONTyped(json, false);
}

export function SystemBoundaryEntityToJSONTyped(value?: SystemBoundaryEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'parentBoundary': SystemBoundaryEntityToJSON(value['parentBoundary']),
        'boundaryType': value['boundaryType'],
        'complianceFrameworks': value['complianceFrameworks'],
        'dataClassifications': value['dataClassifications'],
        'authorizationStatus': value['authorizationStatus'],
        'authorizationDate': value['authorizationDate'] == null ? undefined : ((value['authorizationDate']).toISOString()),
        'authorizationExpiration': value['authorizationExpiration'] == null ? undefined : ((value['authorizationExpiration']).toISOString()),
        'daysUntilExpiration': value['daysUntilExpiration'],
        'isExpired': value['isExpired'],
        'authorizationAuthority': value['authorizationAuthority'],
        'authorizationReference': value['authorizationReference'],
        'boundaryAttributes': value['boundaryAttributes'],
        'networkScope': value['networkScope'],
        'dataFlows': value['dataFlows'],
        'assets': value['assets'] == null ? undefined : (Array.from(value['assets'] as Set<any>).map(AssetEntityToJSON)),
        'users': value['users'] == null ? undefined : (Array.from(value['users'] as Set<any>).map(UserToJSON)),
        'cases': value['cases'] == null ? undefined : (Array.from(value['cases'] as Set<any>).map(CaseToJSON)),
        'vulnerabilities': value['vulnerabilities'] == null ? undefined : (Array.from(value['vulnerabilities'] as Set<any>).map(VulnerabilityInstanceEntityToJSON)),
        'weaknesses': value['weaknesses'] == null ? undefined : (Array.from(value['weaknesses'] as Set<any>).map(WeaknessInstanceEntityToJSON)),
        'assetCount': value['assetCount'],
        'aggregatedRiskScore': value['aggregatedRiskScore'],
        'complianceStatus': value['complianceStatus'],
        'complianceScore': value['complianceScore'],
        'complianceAssessedAt': value['complianceAssessedAt'] == null ? undefined : ((value['complianceAssessedAt']).toISOString()),
        'defaultBaselines': value['defaultBaselines'] == null ? undefined : (Array.from(value['defaultBaselines'] as Set<any>).map(BaselineEntityToJSON)),
        'defaultBaselineId': value['defaultBaselineId'],
        'active': value['active'],
        'decommissioned': value['decommissioned'],
    };
}

